module.exports = __webpack_public_path__ + "34bc775d/img/revit-icon.5ff0d581.svg";